import Dashboard from './Dashboard';

export default Dashboard;
export * from './Dashboard';
